<template>
    <div id="lt-yantr-v2" class="mortgage-rate-table yantr-tracking">
        <div v-show="!HideFilters" id="inputs" class="rate-table-filter">
            <div class="zip-sec">
                <div class="title-block">
                    <component :is="headlineTag">
                        <span>{{ LoanProgram }} {{ LoanType }}</span> rates in <span v-if="!ShowLocation && IsZipCodeEmpty" class="geo-location">United States</span> <span v-else-if="GeoLocationData.state" class="geo-location">{{ GeoLocationData.city + ', ' + GeoLocationData.state }}</span>
                    </component>
                </div>
                <div class="time-stamp-block">
                    <div class="time-stamp-block-inner">
                        <time-stamp v-if="ShowTimeStamp" />
                        <div v-else-if="headerText && headerText.length > 0" class="header-block" v-html="headerText"></div>
                        <div v-if="ShowHdltgp" class="dsk-lt-paid">
                            <tooltip-view :label="ltPaidTitle" :show-on-over="ShowOnOver" :popper-content="ltPaidDescription" referenceElement="open me" />
                        </div>
                    </div>
                    <div class="adv-disclosure-block">
                        <button v-if="ShowHdltgp" id="ltPaidBtn" class="lt-paid a11y-modal-trigger" data-target="ltPaid">
                            {{ ltPaidTitle }}
                        </button>

                        <advertising-disclosures
                            v-if="DisclosureText"
                            :disclosure-text="DisclosureText"
                            :disclosure-tokens="DisclosureTokens"
                            :open-disclosure-modal="openDisclosureModal"
                        />
                    </div>
                </div>
            </div>
            <div class="filter-btn">
                <button class="btn" @click="openFilter(true)"><i class="lt-icons lt4-Funnel"></i> Filter Results (6)</button>
            </div>
            <div class="filter-overlay" :class="{ 'active': ShowFilter}"></div>
            <div class="filter-sec" :class="{ 'active': ShowFilter}">
                <h5 class="filter-mob-header">Filter results by: <i class="lt-icons lt4-Ex" @click="openFilter(false)"></i></h5>
                <ul class="filter-block">
                    <li v-if="!hideLoanTypeFilter" class="loan-type" :class="LoanTypeNav ? 'active' : ''">
                        <i :class="LoanTypeNav ? 'lt4-Minus' : 'lt4-Plus'"></i>
                        <div class="filter-result" @click="LoanTypeNav = !LoanTypeNav">
                            <label>{{ labelLoanType }}</label>
                            <b>{{ LoanType }}</b>
                        </div>
                        <drop-down v-model="LoanType" :label="labelLoanType" :options="MortgageRateList" />
                    </li>
                    <li class="estimated-property-value" :class="PropertyValueNav ? 'active' : ''">
                        <i :class="PropertyValueNav ? 'lt4-Minus' : 'lt4-Plus'"></i>
                        <div class="filter-result" @click="PropertyValueNav = !PropertyValueNav">
                            <label>{{ labelEstimatedPropertyValue }}</label>
                            <b>{{ EstimatedPropertyValue }}</b>
                        </div>
                        <number-input
                            v-model="EstimatedPropertyValue"
                            :label="labelEstimatedPropertyValue"
                            :tooltip-link="HomeValTooltip"
                            :show-tooltip-loader="showTooltipLoader"
                            inputmode="decimal"
                            @inputBlur="inputValueChanged('EstimatedPropertyValue')"
                        />
                    </li>
                    <li v-show="LoanType == 'Purchase'" class="estimated-down-payment" :class="DownPaymentNav ? 'active' : ''">
                        <i :class="DownPaymentNav ? 'lt4-Minus' : 'lt4-Plus'"></i>
                        <div class="filter-result" @click="DownPaymentNav = !DownPaymentNav">
                            <label>{{ labelEstimatedDownPayment }}</label>
                            <b>{{ EstimatedDownPayment }}</b>
                        </div>
                        <number-input
                            v-model="EstimatedDownPayment"
                            :label="labelEstimatedDownPayment"
                            :tooltip-link="DownPaymentTooltip"
                            :show-tooltip-loader="showTooltipLoader"
                            inputmode="decimal"
                            @inputBlur="inputValueChanged('EstimatedDownPayment')"
                        />
                    </li>
                    <li v-show="LoanType == 'Refinance'" class="current-mortgage-balance" :class="MortgageBalanceNav ? 'active' : ''">
                        <i :class="MortgageBalanceNav ? 'lt4-Minus' : 'lt4-Plus'"></i>
                        <div class="filter-result" @click="MortgageBalanceNav = !MortgageBalanceNav">
                            <label>{{ labelCurrentMortgageBalance }}</label>
                            <b>{{ CurrentMortgageBalance }}</b>
                        </div>
                        <number-input
                            v-model="CurrentMortgageBalance"
                            :label="labelCurrentMortgageBalance"
                            inputmode="decimal"
                            @inputBlur="inputValueChanged('CurrentMortgageBalance')"
                        />
                    </li>
                    <li class="property-use" :class="PropertyUseNav ? 'active' : ''">
                        <i :class="PropertyUseNav ? 'lt4-Minus' : 'lt4-Plus'"></i>
                        <div class="filter-result" @click="PropertyUseNav = !PropertyUseNav">
                            <label>{{ labelPropertyUse }}</label>
                            <b>{{ PropertyUse }}</b>
                        </div>
                        <drop-down
                            v-model="PropertyUse"
                            :label="labelPropertyUse"
                            :options="PropertyUseList"
                        />
                    </li>
                    <li class="credit-score" :class="CreditScoreBandIdNav ? 'active' : ''">
                        <i :class="CreditScoreBandIdNav ? 'lt4-Minus' : 'lt4-Plus'"></i>
                        <div class="filter-result" @click="CreditScoreBandIdNav = !CreditScoreBandIdNav">
                            <label>{{ labelEstimatedCreditScoreBandId }}</label>
                            <b>{{ selectedCreditScoreText }}</b>
                        </div>
                        <drop-down
                            v-model="EstimatedCreditScoreBandId"
                            :label="labelEstimatedCreditScoreBandId"
                            :options="CreditScoreList"
                            :tooltip-link="CreditScoreTooltip"
                            :show-tooltip-loader="showTooltipLoader"
                        />
                    </li>
                    <li class="zip-code" :class="ZipCodeUseNav ? 'active' : ''">
                        <i :class="ZipCodeUseNav ? 'lt4-Minus' : 'lt4-Plus'"></i>
                        <div class="filter-result" @click="ZipCodeUseNav = !ZipCodeUseNav">
                            <label>{{ labelZipCode }}</label>
                            <b>{{ GeoLocationData.zipCode }}</b>
                        </div>
                        <geo-by-zip-input
                            ref="geoByZip"
                            v-model="GeoLocation"
                            :label="labelZipCode"
                            :zip-code="GeoLocationData.zipCode"
                            @showHideLocation="showHideLocation()"
                            @input="getGeoDetails"
                        />
                    </li>
                    <li class="refresh-sec">
                        <button type="submit" class="btn" @click="updateRates()">{{ updateRatesButtonText }}</button>
                    </li>
                    <li class="rates-link">
                        <button class="btn" type="submit" @click="updateRates()">{{ updateRatesButtonText }}</button>
                    </li>
                </ul>
            </div>
        </div>
        <mortgage-rate-table-tabbed
            :loan-type="SelectedLoanType"
            :offer-result="OfferResult"
            :loan-programs="LoanPrograms"
            :loan-amount="LoanAmount"
            :zip-code="ZipCode"
            :home-value="EstimatedPropertyValue"
            :show-loading="ShowLoading"
            :show-no-offers="ShowNoOffers"
            :purchRefi="LoanType"
            :destination-link-or-id="destinationLinkOrId"
            :destination-button-text="destinationButtonText"
            :field-edited="FieldEdited"
            :cta-params="ctaParams"
            :default-loan-program="loanTab"
        />
        <a11y-modal v-if="ShowHdltgp" id="ltPaid">
            <template #h4> {{ ltPaidTitle }} </template>
            <div slot="body">
                <div class="description"> <p> {{ ltPaidDescription }} </p></div>
            </div>
        </a11y-modal>

    </div>
</template>

<script>
    import Accounting from 'accounting';

    import A11yModal from '~/components/a11y-modal.vue';
    import AdvertisingDisclosures from '~/components/advertising-disclosures.vue';
    import DropDown from '~/components/drop-down.vue';
    import GeoByZipInput from '~/components/geo-by-zip-input.vue';
    import NumberInput from '~/components/number-input.vue';
    import TimeStamp from '~/components/time-stamp.vue';
    import TooltipView from '~/components/tooltip-view.vue';

    import CreditScoreList from '~/constants/credit-score-list';
    import LoanTypeList from '~/constants/loan-type-list';
    import DefaultTooltip from '~/constants/tooltip-defaults';

    import { getFinancialApiUrl, setHeader } from '~/helpers/financialapi-url-env';
    import QueryStringHelper from '~/helpers/query-string-helper';

    import GetLocation from '~/mixin/get-geo-location';
    import GraphQLMixin from '~/mixin/graphql';
    import InteractionTracking from '~/mixin/interaction-tracking';
    import RateTableMixin from '~/mixin/rate-table';

    import MortgageRateTableTabbed from './components/mortgage-rate-table-tabbed.vue';
    import getMortgageOffers from './getMortgageOffers.gql';

    export default {
        props: {
            labelLoanType: {
                default: 'Loan Type',
            },
            labelEstimatedPropertyValue: {
                default: 'Home Value',
            },
            estimatedPropertyValue: {
                default: 250000,
            },
            loanAmount: {
                default: 0,
            },
            labelEstimatedDownPayment: {
                default: 'Down Payment',
            },
            estimatedDownPayment: {
                default: 50000,
            },
            labelCurrentMortgageBalance: {
                default: 'Mortgage Balance',
            },
            labelZipCode: {
                default: 'Zip Code',
            },
            currentMortgageBalance: {
                default: 200000,
            },
            labelPropertyUse: {
                default: 'Property Use',
            },
            propertyUse: {
                default: 'Primary Home',
            },
            loanType: {
                default: 'Refinance',
            },
            labelEstimatedCreditScoreBandId: {
                default: 'Credit Score',
            },
            estimatedCreditScoreBandId: {
                default: 'Good',
            },
            updateRatesButtonText: {
                default: 'Update',
            },
            homeValTooltip: {
                default: DefaultTooltip.HomeVal,
            },
            downPaymentTooltip: {
                default: DefaultTooltip.DownPayment,
            },
            creditScoreTooltip: {
                default: DefaultTooltip.CreditScore,
            },
            disclosureText: {
                default: 'Disclosures',
            },
            disclosureTokens: {
                default: '00001,000127',
            },
            showLocation: {
                default: true,
            },
            showTimeStamp: {
                default: 'true',
            },
            hideFilters: {
                default: 'false',
            },
            headerText: {
                default: '',
            },
            showFilter: {
                default: false,
            },
            loanTypeNav: {
                default: false,
            },
            propertyValueNav: {
                default: false,
            },
            downPaymentNav: {
                default: false,
            },
            mortgageBalanceNav: {
                default: false,
            },
            zipCodeUseNav: {
                default: false,
            },
            creditScoreBandIdNav: {
                default: false,
            },
            propertyUseNav: {
                default: false,
            },
            graphQlUri: {
                default: '',
            },
            ltPaidDescription: {
                default: 'LendingTree is compensated by companies on this site and this compensation may impact how and where offers appears on this site (such as the order). LendingTree does not include all lenders, savings products, or loan options available in the marketplace.',
            },
            destinationLinkOrId: {
                default: '',
            },
            hideLoanTypeFilter: {
                default: false,
            },
            destinationButtonText: {
                default: 'Get Free Offers',
            },
            showOnOver: {
                default: true,
            },
            ltPaidTitle: {
                default: 'How Does LendingTree Get Paid?',
            },
            openDisclosureModal: {
                default: true,
            },
            showTooltipLoader: {
                default: false,
            },
            ctaParams: {
                default: '',
            },
            loanProgram: {
                default: '',
            },
            loanTab: {
                default: '',
            },
            headlineTag: {
                default: 'h3',
            },
            hideHdltgp: {
                default: false,
            },
        },
        data() {
            return {
                GeoLocation: {
                    zipCode: this.zipCode,
                },
                LoanType: this.loanType,
                EstimatedPropertyValue: this.estimatedPropertyValue,
                EstimatedDownPayment: this.estimatedDownPayment,
                CurrentMortgageBalance: this.currentMortgageBalance,
                EstimatedCreditScoreBandId: this.estimatedCreditScoreBandId,
                MortgageRateList: LoanTypeList.MortgageRateList,
                CreditScoreList: CreditScoreList.mortgageRateTable,
                HomeValTooltip: parseInt(this.hideTooltip, 10) ? '' : this.homeValTooltip,
                DownPaymentTooltip: this.showTooltip(),
                CreditScoreTooltip: parseInt(this.hideTooltip, 10) ? '' : this.creditScoreTooltip,
                DisclosureText: this.disclosureText,
                DisclosureTokens: this.disclosureTokens,
                ShowLocation: this.showLocation,
                HideFilters: this.hideFilters.toLowerCase() === 'true',
                ShowTimeStamp: this.showTimeStamp.toLowerCase() === 'true' && this.headerText.length === 0,
                PropertyUseList: LoanTypeList.MortgagePropertyUseList,
                PropertyUse: this.propertyUse,
                ShowFilter: this.showFilter,
                PropertyValueNav: this.propertyValueNav,
                DownPaymentNav: this.downPaymentNav,
                MortgageBalanceNav: this.mortgageBalanceNav,
                ZipCodeUseNav: this.zipCodeUseNav,
                PropertyUseNav: this.propertyUseNav,
                CreditScoreBandIdNav: this.creditScoreBandIdNav,
                LoanTypeNav: this.loanTypeNav,
                LoanAmount: this.loanAmount,
                OfferResult: [],
                LoanPrograms: [],
                ZipCode: this.zipCode,
                ShowLoading: false,
                ShowNoOffers: false,
                SelectedLoanType: this.loanType,
                ShowOnOver: this.showOnOver,
                ShowHdltgp: !this.hideHdltgp,
                FieldEdited: 'no',
                LoanProgram: 'Mortgage',
                IsZipCodeEmpty: true,
            };
        },
        methods: {
            async updateRates() {
                this.ShowLoading = true;
                this.ShowNoOffers = false;
                this.SelectedLoanType = this.LoanType;
                this.LoanAmount = this.calculatedLoanAmount;
                const variables = {
                    loanPurpose: this.LoanType,
                    creditBand: this.EstimatedCreditScoreBandId,
                    loanAmount: this.LoanAmount,
                    propertyUse: this.PropertyUse,
                    state: this.GeoLocation.state,
                    loanType: this.getLoanProgram(),
                    downPaymentPercent: this.LoanType === 'Purchase' && Accounting.unformat(this.EstimatedPropertyValue) > 0
                        ? Accounting.unformat(this.EstimatedDownPayment) / Accounting.unformat(this.EstimatedPropertyValue) * 100
                        : 0,
                    ltvPercent: this.LoanType === 'Refinance' && Accounting.unformat(this.EstimatedPropertyValue) > 0
                        ? this.calculatedLoanAmount / Accounting.unformat(this.EstimatedPropertyValue) * 100
                        : 0,
                };
                const data = await this.graphQlQuery(getMortgageOffers, variables);
                if (data && data.result) {
                    const { result } = data;
                    this.OfferResult = null;
                    this.LoanPrograms = [];
                    this.$nextTick(() => {
                        if (result && result.length > 0) {
                            const loanPrograms = [...new Set(result.map(item => item.loanProgram))];
                            if (loanPrograms && loanPrograms.length > 0) {
                                const tabs = ['30 YR FIXED', '15 YR FIXED', '30 YR 5/1 ARM'];
                                tabs.forEach((tab) => {
                                    this.LoanPrograms.push(tab);
                                });
                            }
                        } else {
                            this.ShowNoOffers = true;
                        }

                        this.OfferResult = result;
                    });
                } else {
                    this.$nextTick(() => {
                        this.ShowNoOffers = true;
                        this.LoanPrograms = null;
                        this.OfferResult = null;
                    });
                }
                this.ShowFilter = false;
                this.ShowLoading = false;
            },
            showHideLocation() {
                this.ShowLocation = !this.ShowLocation;
            },
            showTooltip() {
                if (parseInt(this.hideTooltip, 10)) return '';
                return this.downPaymentTooltip;
            },
            async initializeOffers() {
                await this.updateRates();
            },
            getGeoDetails(location) {
                this.GeoLocation.city = location.city;
                if (this.ShowLocation) {
                    this.Zipcode = location.zipCode;
                    this.GeoLocation.state = location.state;
                } else {
                    this.IsZipCodeEmpty = true;
                    if (!this.ShowLocation && this.Zipcode === this.$refs.geoByZip.initialiZipCode && this.$refs.geoByZip.IsZipCodeValid && this.$refs.geoByZip.ZipCode !== '') {
                        this.Zipcode = location.zipCode;
                        this.GeoLocation.state = location.state;
                        this.IsZipCodeEmpty = false;
                    } else if (this.$refs.geoByZip.ZipCode === '') {
                        this.GeoLocation.zipCode = '';
                        this.Zipcode = '';
                        this.GeoLocation.state = '';
                    }
                }
                this.$nextTick(() => {
                    this.initializeOffers();
                });
            },
            inputValueChanged(inputField) {
                const minValue = 100000;
                const maxValue = 2000000;
                if (inputField === 'EstimatedPropertyValue') {
                    const propertyValue = Accounting.unformat(this.EstimatedPropertyValue);
                    if (propertyValue < minValue) this.EstimatedPropertyValue = Accounting.format(minValue);
                    else if (propertyValue > maxValue) this.EstimatedPropertyValue = Accounting.format(maxValue);
                } else if (inputField === 'CurrentMortgageBalance') {
                    const mortgageBalance = Accounting.unformat(this.CurrentMortgageBalance);
                    if (mortgageBalance < minValue) this.CurrentMortgageBalance = Accounting.format(minValue);
                    else if (mortgageBalance > maxValue) this.CurrentMortgageBalance = Accounting.format(maxValue);
                } else if (inputField === 'EstimatedDownPayment') {
                    const minDownPayment = 50000;
                    const downPayment = Accounting.unformat(this.EstimatedDownPayment);
                    if (downPayment > Accounting.unformat(this.EstimatedPropertyValue)) this.EstimatedDownPayment = Accounting.format(minDownPayment);
                }
            },
            openFilter(value) {
                this.ShowFilter = value;
            },
            getDetailsFromQueryString() {
                const zipCode = QueryStringHelper.getQueryStringParam('zipcode');
                if (zipCode && zipCode.length > 0) {
                    this.ZipCode = zipCode;
                    GetLocation.methods.GetZipCode(zipCode, this.checkLocationResponse);
                }
            },
            checkLocationResponse(zipDetails) {
                if (!zipDetails.err) {
                    this.$nextTick(() => {
                        this.$refs.geoByZip.updateLocation(zipDetails);
                    });
                }
            },
            updateLocation(val) {
                this.state = val.state;
            },
            defaultLocationByIp() {
                GetLocation.methods.GetIpAddress(this.updateLocation);
            },
            getLoanProgram() {
                if (this.loanProgram) {
                    const loanProgramLowerCase = this.loanProgram.toLowerCase();
                    if (loanProgramLowerCase === 'va') {
                        return 'IsVALoan';
                    }
                    if (loanProgramLowerCase === 'fha') {
                        return 'IsFHALoan';
                    }
                }

                return 'Non-VALoan';
            },
        },
        computed: {
            calculatedLoanAmount() {
                if (this.LoanType === 'Refinance') {
                    return Accounting.unformat(this.CurrentMortgageBalance);
                }
                if (this.LoanType === 'Purchase') {
                    return Accounting.unformat(this.EstimatedPropertyValue) - Accounting.unformat(this.EstimatedDownPayment);
                }

                return Accounting.unformat(this.CurrentMortgageBalance);
            },
            selectedCreditScoreText() {
                return this.CreditScoreList.find(obj => obj.value === this.EstimatedCreditScoreBandId).text;
            },
            GeoLocationData() {
                return this.GeoLocation;
            },
        },
        mounted() {
            this.defaultLocationByIp();
            this.GraphQlUri = this.graphQlUri !== '' ? this.graphQlUri : getFinancialApiUrl();
            this.createGraphQlClient(this.GraphQlUri, setHeader);
            if (this.loanProgram) {
                const loanProgramLowerCase = this.loanProgram.toLowerCase();
                if (loanProgramLowerCase === 'va' || loanProgramLowerCase === 'fha') {
                    this.LoanProgram = this.loanProgram.toUpperCase();
                }
            }
        },
        created() {
            this.getDetailsFromQueryString();
        },
        components: {
            NumberInput,
            DropDown,
            AdvertisingDisclosures,
            MortgageRateTableTabbed,
            GeoByZipInput,
            TimeStamp,
            A11yModal,
            TooltipView,
        },
        watch: {
            LoanType(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.FieldEdited = 'yes';
                }
            },
            EstimatedPropertyValue(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.FieldEdited = 'yes';
                }
            },
            EstimatedDownPayment(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.FieldEdited = 'yes';
                }
            },
            CurrentMortgageBalance(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.FieldEdited = 'yes';
                }
            },
            PropertyUse(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.FieldEdited = 'yes';
                }
            },
            EstimatedCreditScoreBandId(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.FieldEdited = 'yes';
                }
            },
        },
        mixins: [InteractionTracking, RateTableMixin, GraphQLMixin, GetLocation],
    };
</script>
<style src="../../assets/styles/v2/common.scss" lang="scss"></style>
<style src="./main.scss" lang="scss"></style>
<style src="../../assets/styles/a11yModal.scss" lang="scss"></style>
